// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"106c47b6","453":"9e4a88ec","732":"c0700719"}[chunkId] + ".chunk.js";
};